import React, { useState, useEffect } from "react";
import { Button, Container, Form, Row, Col, Spinner, Alert, Card, Dropdown, Table } from "react-bootstrap";
import axiosInstance from '../components/AxiosInstance';
import { API_URL } from "../Config";
import { FaEye } from 'react-icons/fa';
import axios from "axios";
import ReceiptDraw from "./ReceiptDraw";

const MyReceipts = () => {
  let [userReceipts, setuserReceipts] = useState([]);
  let [userReceipts1, setuserReceipts1] = useState([]);
  const [vendorTypes, setvendorTypes] = useState([]);
  const [category, setCategory] = useState("Select Category");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    setLoading(true);
    getUserReceipts();
    getVendorTypes();
  }, []);

  const getUserReceipts = async () => {
    try {
      let url = API_URL + "dashboard/getAllUserReceipts";
      const res = await axiosInstance.get(url);
      if (res.data && res.data.userReceipts) {
        setuserReceipts(res.data.userReceipts);  // Adjust based on API structure
        setuserReceipts1(res.data.userReceipts);
      } else {
        setError('Invalid user data structure.');
      }
      setLoading(false);
    } catch (err) {
      setError("Unable to fetch Dashboard data. Please try again!");
      setLoading(false);
    }
  };

  const getVendorTypes = async () => {
    try {
      let url = API_URL + "vendor/getVendorTypes";
      const res = await axios.get(url);
      if (res.data && res.data.vendorTypes) {
        setvendorTypes(res.data.vendorTypes);  // Adjust based on API structure
      } else {
        setError('Invalid user data structure.');
      }
      setLoading(false);
    } catch (err) {
      setError("Unable to fetch Dashboard data. Please try again!");
      setLoading(false);
    }
  };

  const handleViewClick = (id) => {
    try {
      let receiptId = userReceipts.find((item) => {
        return item.id === id;
      });
      const receipt = JSON.parse(receiptId["Receipt"]);
      setModalData(receipt);
    } catch (error) {
      setError('Error fetching receipt details:', error);
    }
    setShow(true);
  };

  const handleSelect = (e) => {
    setCategory(e);
  }

  const handleClose = () => setShow(false);

  const [searchQuery, setSearchQuery] = useState("");
  const handleChange = (e) => {
    setSearchQuery(e.target.value);
    if (searchQuery.length > 0) {
      const filteredReceipts = userReceipts1.filter((r) => {
        const loweredSearch = searchQuery.toLowerCase();
        return (
          r.VendorName.toLowerCase().includes(loweredSearch) ||
          r.VendorType.toLowerCase().includes(loweredSearch) ||
          r.ReceiptDate.toLowerCase().includes(loweredSearch) ||
          r.Amount.toLowerCase().includes(loweredSearch)
        );
      });
      setuserReceipts(filteredReceipts);
    }
    else {
      setuserReceipts(userReceipts);
    }
  }


  return (
    <div>
      <br /><br /><br /><br />
      <Container className="hero-section1 rounded-3">
        <div className=" text-center">
          <span className="highlight-text">
            Receipts
          </span>
        </div>
        {loading ? (
          <Col className="d-flex justify-content-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        ) : error ? (
          <Col className="d-flex justify-content-center">
            <Alert variant="danger">{error}</Alert>
          </Col>
        ) : (
          <>
            <div>
              <Row className="mt-4">
                <Col>
                  <Dropdown onSelect={handleSelect}>
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                      {category === "Select Category" ? "Select Category" : ""}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {vendorTypes.map((item) => (
                        <Dropdown.Item eventKey={item.id}>{item.vendortype_name}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col>
                  <Form.Control id="search" type="text" placeholder="Search any" name="search" value={searchQuery} onChange={handleChange} />
                </Col>
              </Row>
            </div>
            <div>
              <Row className="mt-4">
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Store Name</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Amount</th>
                      <th>View Receipt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userReceipts.map((item) => (
                      <tr key={item.id}>
                        <td>{item.VendorType}</td>
                        <td>{item.VendorName}</td>
                        <td>{item.ReceiptDate}</td>
                        <td>{item.ReceiptTime}</td>
                        <td>{item.Amount}</td>
                        <td>
                          <button
                            onClick={() => handleViewClick(item.id)}
                            className="btn btn-link"
                          >
                            <FaEye /> {/* View Icon */}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </div>
          </>
        )}
      </Container>
      <ReceiptDraw
        show={show}
        onHide={handleClose}
        data={modalData}
      />
    </div>
  );
};

export default MyReceipts;
